import script from "./EcoPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./EcoPopup.vue?vue&type=script&setup=true&lang=ts"

import "./EcoPopup.vue?vue&type=style&index=0&id=6b009da5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b009da5"]])

export default __exports__